import RiskLevelCharts from "../../../../components/risk-level-charts.jsx";

export default function CpfRiskLevel({data}) {
    const cards = data?.cards;

    return (
        <RiskLevelCharts
            total={cards?.cpfRegistrations}
            activeTotal={cards?.activeCpfRegistrations}
            appsActive={cards?.citizenAppsActive}
            riskLevels={data?.cpfRiskLevels}
        />
    );
}
